import { Box, MenuItem, Select, SelectChangeEvent, Typography, useTheme } from "@material-ui/core";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { GridApi } from "ag-grid-community";
import * as React from "react";
import { useTranslation } from "react-i18next";

type RowsPerPageProps = {
  initialPageSize: number;
  pageSizes: number[];
  gridApi: GridApi;
};

export function RowsPerPage(props: RowsPerPageProps): React.ReactElement {
  const { gridApi, initialPageSize, pageSizes } = props;
  const theme = useTheme();
  const { t } = useTranslation();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [rowsPerPage, setRowsPerPage] = React.useState(initialPageSize ?? 100);

  function handleChange(event: SelectChangeEvent<any>) {
    const {
      target: { value }
    } = event;
    setRowsPerPage(value);
    gridApi.paginationSetPageSize(Number(value));
  }

  if (isMobile) {
    return null;
  }

  return (
    <Box display="flex" marginLeft="0.75rem" alignItems="center">
      <Typography variant="body2" marginRight="0.35rem">
        {t("general.grid.pageSize")}
      </Typography>
      <Select
        style={{ height: 35, fontSize: "0.9rem" }}
        id="rows-per-page"
        value={rowsPerPage}
        onChange={handleChange}
      >
        {[...new Set([initialPageSize, ...pageSizes])].map((value) => (
          <MenuItem key={value} value={value}>
            {value}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
}
